export const useRouteStore = defineStore('routeStore', () => {
  const router = useRouter();

  const hwRoutes = router?.currentRoute?.value;

  // @NOTE: hwroute object keys needs to equal the one used on the composable useRoutes and routeStore
  const hwroute = ref({
    langUrl: null,
    propertyTypeUrl: null,
    continentUrl: null,
    countryUrl: null,
    cityUrl: null,
    cityPageNumber: null,
    propertyIdUrl: null,
    propertyNameUrl: null,
    areaUrl: null,
    regionUrl: null,
    districtUrl: null,
    districtPageNumber: null,
    chainUrl: null,
    cityFilterUrl: null,
    districtFilterUrl: null,
    genericUrl: null,
  });

  const propertyTypeKey = ref('hostel');

  const langUrls = ref({});

  const getPageKey = computed(() => {
    const currentRouteMatch = hwRoutes?.matched?.[0];
    const currentRoutePath = currentRouteMatch?.path;
    const currentRouteName = currentRouteMatch?.name;

    if (currentRoutePath?.match(/^\/events\/$/)) {
      return 'eventsWorldwide';
    } else if (currentRoutePath?.match(/^\/events\/:continent\/:country\/:city/)) {
      return 'eventsCity';
    } else if (currentRoutePath?.match(/^\/events\/:continent\/:country/)) {
      return 'eventsCountry';
    } else if (currentRoutePath?.match(/^\/events\/:continent/)) {
      return 'eventsContinent';
    } else if (currentRoutePath?.match(/^\/events\/e\/:eventId/)) {
      return 'eventDetails';
    } else if (currentRoutePath?.match(/\/p\/:propertyId/)) {
      return 'property';
    } else if (currentRoutePath?.match(/\/d\/:district/)) {
      return 'district';
    } else if (currentRoutePath?.match(/\/:city/)) {
      return 'city';
    } else if (currentRoutePath?.match(/\/r\/:region/)) {
      return 'region';
    } else if (currentRoutePath?.match(/\/a\/:area/)) {
      return 'area';
    } else if (currentRoutePath?.match(/\/:country/)) {
      return 'country';
    } else if (currentRoutePath?.match(/\/:continent/)) {
      return 'continent';
    } else if (currentRoutePath?.match(/\/:propertyType/)) {
      return 'worldwide';
    } else if (currentRouteName?.match(/^index_/)) {
      return 'homepage';
    } else if (currentRoutePath?.match(/\/:brand/)) {
      return 'chain';
    } else if (currentRoutePath?.match(/^\/legal\/:legalPage/)) {
      return 'legal';
    } else if (currentRoutePath?.match(/^\/search\/?$/)) {
      return 'search';
    } else {
      return 'generic';
    }
  });

  const getPropertyType = computed(() => {
    return propertyTypeKey?.value;
  });

  const getRoute = computed(() => {
    return hwroute?.value;
  });

  const getAllRoutesFromLang = computed(() => () => {
    return langUrls?.value || null;
  });

  const getRouteFromLang = computed(() => (lang) => {
    return langUrls?.value?.[lang] || null;
  });

  const isHomePage = computed(() => {
    return !hwroute?.value.propertyTypeUrl && !hwroute?.value.genericUrl;
  });

  const isHomePageRoute = computed(() => {
    return hwRoutes?.name?.match(/^index/);
  });

  const isDistrictPage = computed(() => {
    return !!hwroute?.value.districtUrl;
  });

  const isCityPage = computed(() => {
    return !!hwroute?.value.cityUrl && !isDistrictPage;
  });

  const isPropertyPage = computed(() => {
    return hwroute?.value.propertyIdUrl > 0;
  });

  const isLegalPage = computed(() => {
    return getPageKey.value === 'legal';
  });

  const isSearchResultsPage = computed(() => {
    return getPageKey.value === 'search';
  });

  function setPropertyType(value) {
    propertyTypeKey.value = value;
  }

  function setRoute({
    langUrl,
    propertyTypeUrl,
    continentUrl,
    countryUrl,
    cityUrl,
    cityPageNumber,
    propertyIdUrl,
    propertyNameUrl,
    areaUrl,
    regionUrl,
    districtUrl,
    districtPageNumber,
    chainUrl,
    cityFilterUrl,
    districtFilterUrl,
    genericUrl,
  }) {
    hwroute.value = {
      langUrl,
      propertyTypeUrl: propertyTypeUrl || null,
      continentUrl: continentUrl || null,
      countryUrl: countryUrl || null,
      cityUrl: cityUrl || null,
      cityPageNumber: cityPageNumber || null,
      propertyIdUrl: propertyIdUrl || null,
      propertyNameUrl: propertyNameUrl || null,
      areaUrl: areaUrl || null,
      regionUrl: regionUrl || null,
      districtUrl: districtUrl || null,
      districtPageNumber: districtPageNumber || null,
      chainUrl: chainUrl || null,
      cityFilterUrl: cityFilterUrl || null,
      districtFilterUrl: districtFilterUrl || null,
      genericUrl: genericUrl || null,
    };
  }

  function setAllRoutesByLang(langUrls) {
    langUrls.value = langUrls;
  }

  function setRoutesByLang(lang, langUrl) {
    langUrls.value[lang] = langUrl;
  }

  return {
    hwroute,
    propertyTypeKey,
    langUrls,
    getPropertyType,
    getRoute,
    getAllRoutesFromLang,
    getRouteFromLang,
    isHomePage,
    isHomePageRoute,
    isCityPage,
    isDistrictPage,
    isPropertyPage,
    isLegalPage,
    isSearchResultsPage,
    getPageKey,
    setPropertyType,
    setRoute,
    setAllRoutesByLang,
    setRoutesByLang,
  };
});
